import React, { useMemo } from "react";
import dynamic from "next/dynamic";
const Section = dynamic(() => import("@/Components/LayoutComponents/Section"),{ssr: true});
import Link from "next/link";
import styles from "./style.module.scss";
const Button = dynamic(() => import("@/Components/Button"),{ssr: true});

type ActionCardProps = {
  block: any;
};

const BuildSection: React.FC<ActionCardProps> = ({ block }) => {
  const titleClassName = "max-w-[1230px]";

  // Build the class name once so SSR and CSR match exactly
  const sectionClassName = useMemo(
    () => `${styles.sectionWrapper} xl:py-[100px] md:py-[95px] py-[56px]`,
    []
  );

  const data = block;

  return (
    <Section className={sectionClassName}>
      <div className={styles.gradientOverlay}>
        <div className={styles.innerGradient} />
      </div>

      <div className="container text-center">
        <h2
          className={`mx-auto font-bold text-primary-text text-heading-1 ${titleClassName}`}
        >
          {data?.title ?? ""}
        </h2>
        <p className="font-regular max-w-[914px] mx-auto text-heading-6 text-secondary-text mt-3">
          {data?.description || ""}
        </p>

        <Link
          href={data?.button?.href || ""}
          className="mx-auto"
          target="_blank"
        >
          <Button
            label={data?.button?.label || ""}
            className="lg:mt-10 mt-8 mx-auto"
          />
        </Link>
      </div>
    </Section>
  );
};
export default BuildSection;
